import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  margin: 0;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 20px;
  background: #e3e4e6;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  .animated {
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.tablet} {
    margin: 0;
    padding: 0;
  }

  ${mediaMaxWidth.phone} {
    padding: "10px 0";
  }
`;

interface IChartTitleProps {
  marginBottom?: number;
  pdfExport?: boolean;
}

export const ChartTitle = styled.div`
  color: #333;
  font-weight: 600;
  font-size: 1em;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  transform: ${(props: IChartTitleProps) => props.pdfExport && "scale(0.75)"};
  width: ${(props: IChartTitleProps) => props.pdfExport && "525px"};
  position: ${(props: IChartTitleProps) => props.pdfExport && "relative"};
  left: ${(props: IChartTitleProps) => props.pdfExport && "-60px"};

  .tooltip-max-width {
    max-width: 20%;
  }
  @media (max-width: 768px) {
    .tooltip-max-width {
      max-width: 50%;
    }
  }
`;

export const ChartTitleText = styled.span`
  ${mediaMaxWidth.phone} {
    width: 160px;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
  }
`;

interface IChartGroupProps {
  pdfExport?: boolean;
}

export const ChartGroup = styled.div`
  display: flex;
  height: ${(props: IChartGroupProps) => !props.pdfExport && "480px"};
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  ${mediaMaxWidth.mediumDesktop} {
    height: ${(props: IChartGroupProps) => !props.pdfExport && "unset"};
    width: ${(props: IChartGroupProps) => !props.pdfExport && "690px"};
    margin: ${(props: IChartGroupProps) => !props.pdfExport && "0 auto"};
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IChartGroupProps) => !props.pdfExport && "100vw"};
  }
`;
